import { toast } from 'react-toastify'
import moment from 'moment';


import { createAxiosInstance, getModificaciones, attachFilesToEntity } from '../utils/helpers'
import { API_URL } from '.'
import * as types from './types'
import history from '../utils/history'

import { displayMessages, showHideModalCreateOtrosi } from './common'
import { displayModalCreateDocumento } from './solicitudservicioot'
import { showHideModalSummary } from './documentos'

import { showHideModalAddAdicional } from './documentos'

export function initReducer() {
	return (dispatch) => {
		dispatch({ type: types.RESETEAR_REDUCER_SOLICITUD_OTROSI })
	}
}


export function getSolicitud(id) {
	const axios = createAxiosInstance()
	return (dispatch) => {
		axios.get(`${API_URL}/solicitudes/otrosi/${id}`)
		.then((res) => {
			const solicitud = res.data.solicitud
			dispatch({ type: types.OBTENER_SOLICITUD_OTROSI, payload: { solicitud } })
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})
	}
}

export function createOtrosi() {
	const axios = createAxiosInstance()

    return (dispatch, getState) => {        

        let modalAddAdicional = getState().documentos.get('modalAddAdicional')
        let otrosi = modalAddAdicional.get('data')
        otrosi = otrosi.set('documento_id', getState().documentos.getIn(['modalSummary', 'data', 'id']))

        axios.post(`${API_URL}/solicitudes/otrosi`, otrosi)
            .then(() => {

				dispatch(showHideModalAddAdicional(false))				
				dispatch(showHideModalCreateOtrosi(false))
				dispatch(initReducer())

				dispatch(displayModalCreateDocumento(false))
				dispatch(showHideModalSummary(false))

                history.push(window.FOLDER + '/solicitudes/abiertas')
				displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
            })
            .catch(err => {
                displayMessages(dispatch, err)
            })

    }
}



































// WEBPACK FOOTER //
// ./src/actions/otrosi.js